import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ palette }) => ({
  container: {
    flexGrow: 1,
    alignItems: "center",
    marginBottom: 23,
  },
  spacer: {
    flexGrow: 1,
    display: "flex",
  },
  name: {
    borderLeft: `2px solid ${palette.grey[200]}`,
    paddingLeft: 24,
    paddingTop: 0,
    paddingBottom: 0,
    marginLeft: 20,
    marginBottom: 0,
  },
  availableBalance: {
    paddingLeft: 24,
  },
  balanceText: {
    fontWeight: 600,
    paddingLeft: 20,
  },
  balanceAmount: {
    paddingLeft: 10,
    paddingRight: 10,
    fontWeight: 600,
  },
}));

export default useStyles;
